import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the tab and its detail routes a "SKU rules" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/sku-rules')({
  staticData: { crumb: 'dictionary:setup.tabs.skuRules' },
  component: Outlet,
});
